export default "__VITE_ASSET__DHup_124__"